import kToast from './Toast.vue'
import Vue from 'vue'

const toastStructor = Vue.extend(kToast)
function f(options = {}) {
  if (typeof options === 'string') {
    options = {
      content: options
    }
  }
  const toastInstence = new toastStructor({data: options})
  toastInstence.showToast(options)
  toastInstence.vm = toastInstence.$mount()
  document.body.appendChild(toastInstence.vm.$el)
}

export default f